import { PIN_OPEN_TYPE } from "@/constants/pinOpenType";
import useAppStore from "@/context/store";
import { useRouter } from "next/router";
import getNextDetailsSetp from "../getHistorySetp";

export function usePin() {
  const { pinOpenType, currentPin } = useAppStore(
    ({ pinOpenType, currentPin }) => ({ pinOpenType, currentPin })
  );
  const router = useRouter();

  const onPinClick = ({
    pin,
    param,
    currentSrc,
    searchWord,
    event,
  }: {
    pin: IPin;
    param?: string;
    currentSrc?: string;
    searchWord?: string;
    event: React.MouseEvent;
  }) => {
    if (event.metaKey || event.ctrlKey || pinOpenType === PIN_OPEN_TYPE.BLANK) {
      return;
    }

    event.preventDefault();

    const pinId = pin.pin_id;
    const href = `/pins/${pinId}${param || ""}`;
    const withSearchWordHref = searchWord
      ? `${href}${href.indexOf("?") !== -1 ? "&" : "?"}searchWord=${searchWord}`
      : href;

    if (pinOpenType === PIN_OPEN_TYPE.BLANK) {
      window.open(withSearchWordHref);
      return;
    }

    const pathname = router.pathname;

    // 判断是采集详情弹窗
    if (pathname === "/pins/[pinId]" && !currentPin) {
      // 用于渐进式显示图片，先显示缓存图，再显示大图，但是这个router.push的方式所以只能把缓存图片地址通过window传递
      window._pinDetailCurrentSrc = currentSrc;
      router.push(withSearchWordHref);
    } else {
      // currentSrc用于渐进式显示图片，先显示缓存图，再显示大图
      useAppStore.setState({
        currentPin: { pinId, currentSrc, searchWord, ...pin },
      });
      let detailsSetp = getNextDetailsSetp();

      window.history.pushState(detailsSetp, null, href);
    }
  };

  return { onPinClick };
}
